import styled from "styled-components";

// Frame and floating controls shared by the map pages.

export const MapContainer = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
  min-height: 420px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.cardBg};
`;

// Bottom-left, above the Google logo: the top edge belongs to the time zone
// strip and Google's own map type / fullscreen buttons.
export const MapControls = styled.div`
  position: absolute;
  left: 10px;
  bottom: 36px;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`;

export const MapChip = styled.button<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 11px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.borderStrong};
  background-color: ${(props) => props.theme.cardBg};
  color: ${(props) =>
    props.$active === false
      ? props.theme.mutedTextColor
      : props.theme.textColor};
  box-shadow: ${(props) => props.theme.shadow.md};
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  cursor: ${(props) => (props.onClick ? "pointer" : "default")};
  transition: background-color 0.15s ease, color 0.15s ease;

  ${(props) =>
    props.onClick
      ? `&:hover { background-color: ${props.theme.surfaceRaised}; color: ${props.theme.textColor}; }`
      : ""}

  svg {
    width: 15px;
    height: 15px;
    color: ${(props) =>
      props.$active ? props.theme.colors.primary : "currentColor"};
  }
`;

// Headline number that leads the toolbar of a map page.
export const MapHeadline = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 8px;
  font-size: 14px;
  color: ${(props) => props.theme.secondaryTextColor};

  strong {
    font-size: 26px;
    font-weight: 650;
    line-height: 1.1;
    letter-spacing: -0.02em;
    font-variant-numeric: tabular-nums;
    color: ${(props) => props.theme.textColor};
  }
`;

export const MapToolbarSpacer = styled.div`
  flex: 1;
`;
